export default "data:image/png;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiYW5kcm9pZC1jaHJvbWUtMTkyeDE5Mi5wbmciOw=="